import { rem } from 'polished';
import styled, { css } from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Background = styled.div`
    background: ${({ theme }) => theme.colors.darkLight};
    margin-bottom: ${rem(240)};
`;

export const Wrapper = styled.div`
    padding: ${rem(20)};
    margin-top: ${rem(40)};
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (min-width: ${breakpoints.lg}px) {
        padding: ${rem(20)} 0;
    }
`;

export const Form = styled.div`
    background: ${({ theme }) => theme.colors.white};
    padding: ${rem(40)};
    border-radius: ${rem(16)};
    margin-bottom: ${rem(-200)};
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.15);
`;

const FormFieldsStyles = css`
    width: 100%;
    padding: ${rem(10)};
    margin-bottom: ${rem(20)};
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${rem(8)};
    display: block;

    &.error {
        margin-bottom: 0;
        border-color: ${({ theme }) => theme.colors.danger};
    }

    @media (min-width: ${breakpoints.md}px) {
        width: ${rem(700)};
    }
`;

export const Input = styled.input`
    ${FormFieldsStyles}
    height: ${rem(50)};
`;

export const ErrorMessage = styled.span`
    margin: ${rem(5)} 0 ${rem(10)} 0;
    display: block;
    font-size: ${({ theme }) => theme.fontSizes.textBase};
    color: ${({ theme }) => theme.colors.danger};
`;

export const GlobalErrorMessage = styled.span`
    color: ${({ theme }) => theme.colors.danger};
    padding-top: ${rem(15)};
    margin-bottom: -${rem(10)};
    display: block;
`;

export const SuccessMessage = styled.span`
    color: ${({ theme }) => theme.colors.green};
    padding-top: ${rem(20)};
    display: block;
`;
